enum ChartAbnormalStatus {
  Loading = 'Loading',
  NoData = 'NoData',
  Error = 'Error',
  NoAccess = 'NoAccess',
}

export default ChartAbnormalStatus;
